angular.module('impactx.smartform').service('SmartFormService', [
    '$q',
    'dataGen',
    SmartFormService]);

function SmartFormService($q, dataGen) {
    var self = this;
    self.trns = [];

    self.getTranslation = function (key) {
        return self.trns[key];
    };

    self.getTranslations = function () {
        if (self.trns.length == 0) {
            return initializeTranslations();
        }
        else {
            var defer = $q.defer();
            defer.resolve(self.trns);

            return defer.promise;
        }

    };

    self.convertObjectToArray = function (object) {
        return convertObjectToArray(object);
    };

    function initializeTranslations() {
        return dataGen.getData({}, {}, '/smartform/translations').then(function (response) {
            var translations = impactX.isDefined(response, 'trns');
            self.trns = translations;
            return translations;
        });
    }

    function convertObjectToArray(object) {
        return $.map(object, function (value) {
            return angular.copy([value]);
        });
    }

    return {
        getTranslation: self.getTranslation,
        getTranslations: self.getTranslations,
        convertObjectToArray: self.convertObjectToArray,
    };
}